import type { ABTestKey } from 'lib/abTests';
import { getIsABTestActive, subscribeToABTests } from 'lib/abTests';
import { useSyncExternalStore } from 'react';

export const useIsABTestActive = (key: ABTestKey) =>
  useSyncExternalStore(
    subscribeToABTests,
    () => getIsABTestActive(key),
    () => false,
  );
